/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Filter_ProblemsInputs */



/**
* | output |
* | --- |
* | "Issues" |
*
* @param {Deck_Filter_ProblemsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_filter_problems = /** @type {((inputs?: Deck_Filter_ProblemsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Filter_ProblemsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Problèmes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problemas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Problemas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problemi")
	return /** @type {LocalizedString} */ ("Issues")
});